module.exports = __webpack_public_path__ + "static/img/01.616d104.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/immark/01.jpg
// module id = 392
// module chunks = 1